import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const soot: ThemeDefinition = {
  label: "Soot",
  className: "theme-soot",
  bg: "#1a1816",
  text: "#b8a898",
  textMuted: "rgba(184,168,152,0.55)",
  accent: "#c08050",
  glassRgb: "26,24,22",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(184,168,152,0.18)",
  selection: "#c08050",
  selectionText: "#1a1816",
  gridColor: "#b8a898",
  noiseOpacity: "0.05",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.55)",
  gpuClear: hexToSrgb("#1a1816"),
  gpuGridLine: hexToLinear("#b8a898"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#c08050"),
  gpuAxisZ: hexToLinear("#b8a898"),
  axisXColor: "#c08050",
  axisZColor: "#b8a898",
  font: '"Space Grotesk", sans-serif',
};
